<div class="sku_image" (click)="previewImage(item.image)">
    <img [src]="item.image" />
</div>

<div class="sku">
    <div class="sku_title sku_product_title" [title]="item.title">
        {{ item.title }}
    </div>

    <div class="sku_chips">
        <app-sku-chip *ngIf="item.sku" [name]="'SKU'" [value]="item.sku" [link]="skuLink">
        </app-sku-chip>

        <app-sku-chip *ngIf="item.asin" [name]="'ASIN'" [value]="item.asin" [link]="asinLink">
        </app-sku-chip>
    </div>
</div>